import { useState } from "react";
import useHttp from "./use_http";
import moment from "moment";

const useStatistics = () => {
  const { httpService } = useHttp();

  const [loadings, setLoadings] = useState({
    getStatistics: false,
  });

  const [filters, setFilters] = useState({
    date: null,
  });

  const [statisticsData, setStatisticsData] = useState([]);

  const getStatistics = async (filters) => {
    let paramsData = {
      startDate: filters.date
        ? moment(filters.date[0].$d).format("YYYY-MM-DD")
        : null,
      endDate: filters.date
        ? moment(filters.date[1].$d).format("YYYY-MM-DD")
        : null,
    };
    try {
      setLoadings({ ...loadings, getStatistics: true });
      const response = await httpService.get("instructor/report/income", {
        params: paramsData,
      });
      setLoadings({ ...loadings, getStatistics: false });
      if (response.data.data) {
        setStatisticsData(response.data.data);
      }
    } catch ({ err, response }) {
      setLoadings({ ...loadings, getStatistics: false });
    }
  };

  const exports = {
    getStatistics,
    statisticsData,
    filters,
    setFilters,
    loadings,
  };
  return exports;
};

export default useStatistics;
